import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { RouterLinkActive, RouterLink } from '@angular/router';

import { Permission } from '../../../../../models/permission';
import { TooltipDirective } from '../../../../../ui-kit/tooltip.directive';
import { PermissionDirective } from '../../../../directives/permission.directive';

export interface MenuItem {
  name: string;
  link: string;
  permission: Permission | Permission[];
  condition: boolean;
  hasBadge: boolean;
  tooltipEnabled?: boolean;
  tooltipTitle?: string;
  tooltipText?: string;
}

@Component({
  selector: 'app-header-menu-item',
  templateUrl: './header-menu-item.component.html',
  styleUrls: ['./header-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PermissionDirective, MatButtonModule, RouterLinkActive, RouterLink, MatBadgeModule, TooltipDirective],
})
export class HeaderMenuItemComponent {
  @Input() menuItem: MenuItem;
  @Output() closeTooltip: EventEmitter<void> = new EventEmitter<void>();

  onCloseTooltip(): void {
    this.closeTooltip.emit();
  }
}
